import {
  Button,
  Table,
  Typography,
  Popconfirm,
  InputNumber,
  Flex,
  Row,
  Col,
  Select,
  Dropdown,
  Input,
  Card,
  Form,
  DatePicker,
} from "antd";
import { PlusOutlined, DeleteOutlined, DownOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { ServicetypeService } from "../../../../Services/Manage/ServicetypeService";
import SubscriptionDropdown from "../../../general/SubscriptionDropdown";
import dayjs from "dayjs";

const { Text } = Typography;

const BlukExpense = ({
  dataSource,
  setDataSource,
  handleNewAdd,
  handleAdd,
  handleDelete,
  handleChange,
  setCategory,
  setVendorId,
  setPoId,
}) => {
  const [vendorOption, setVendorOption] = useState([]);
  const [form] = Form.useForm();
  const [lastPO, setLastPO] = useState("");

  const lastAddedPO = async () => {
    try {
      const response = await ServicetypeService.lastAddedBillId();
      const lastPOValue = response?.data?.bill_id;
      const newPO = generateNextPO(lastPOValue);
      setLastPO(newPO);
      setPoId(newPO);
      form.setFieldsValue({ bill_id: newPO });
    } catch (error) {
      console.error("Error fetching last PO:", error);
      const newPO = generateNextPO(null);
      setLastPO(newPO);
      form.setFieldsValue({ bill_id: newPO });
      setPoId(newPO);
    }
  };

  const GetAllVendors = async () => {
    try {
      const request = await ServicetypeService.getAllVendors();
      setVendorOption(
        request.data.map((item, index) => ({
          label: item.name,
          value: item.id,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    GetAllVendors();
    lastAddedPO();
  }, []);

  const columns = [
    {
      title: "SI No",
      dataIndex: "key",
      width: "7%",
      align: "center",
      render: (_, __, index) => index + 1,
    },

    {
      title: "Description",
      dataIndex: "description",
      width: "30%",
      render: (text, record) => (
        <TextArea
          size="large"
          allowClear
          rows={2}
          value={text}
          onChange={(e) =>
            handleChange(record.id ?? record.key, "description", e.target.value)
          }
        />
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          min={0}
          size="large"
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "qty", value)
          }
        />
      ),
    },

    {
      title: "Subscription",
      children: [
        {
          title: "Date",
          dataIndex: "expense_date",
          key: "expense_date",
          width: "10%",
          align: "center",
          render: (text, record) => (
            <DatePicker
              size="large"
              format="YYYY-MM-DD"
              value={text ? dayjs(text.split("T")[0]) : null}
              onChange={(date, dateString) =>
                handleChange(
                  record.id ?? record.key,
                  "expense_date",
                  dateString
                )
              }
              style={{
                width: "100%",
                fontSize: 13,
                height: 28,
              }}
            />
          ),
        },
        {
          title: "Subscription Type",
          dataIndex: "subscription_type",
          key: "subscription_type",
          width: "14%",
          align: "center",
          render: (text, record) => (
            <SubscriptionDropdown
              value={text}
              size="large"
              onChange={(val) =>
                handleChange(record.id ?? record.key, "subscription_type", val)
              }
            />
          ),
        },
      ],
    },

    {
      title: "Unit Price",
      dataIndex: "unitprice",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="large"
          min={0}
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "unitprice", value)
          }
        />
      ),
    },
    {
      title: "Tax",
      dataIndex: "tax",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          min={0}
          size="large"
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "tax", value)
          }
        />
      ),
    },
    {
      title: "Total Price",
      dataIndex: "totalprice",
      align: "center",
      render: (text) => <Text>{text}</Text>,
      width: "10%",
    },
    {
      title: "Action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <>
          <Button
            icon={<PlusOutlined />}
            type="dashed"
            size="large"
            style={{ marginRight: 8 }}
            onClick={() => handleAdd(record.id ?? record.key)}
          />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  const generateNextPO = (lastPOValue) => {
    const currentYear = new Date().getFullYear();

    if (!lastPOValue) {
      return `BILL-${currentYear}-001`;
    }

    const match = lastPOValue.match(/^BILL-(\d{4})-(\d+)$/);

    if (!match) {
      return `BILL-${currentYear}-001`;
    }

    const [_, yearStr, numberStr] = match;
    const year = parseInt(yearStr);
    const number = parseInt(numberStr);

    if (year === currentYear) {
      const nextNumber = number + 1;
      return `BILL-${year}-${String(nextNumber).padStart(3, "0")}`;
    } else {
      // New year → reset counter
      return `BILL-${currentYear}-001`;
    }
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        {/* <Row justify="space-between" align="middle">
          <Col>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Purchase Order
            </Typography.Title>
          </Col>

          <Col>
            
          </Col>
        </Row> */}
      </div>

      <Card>
        <Form layout="vertical" form={form}>
          <Row gutter={16} align="bottom">

            {/* Bill ID */}
            <Col span={4}>
              <Form.Item label="Bill ID" name="bill_id">
                <Input size="large" readOnly value={lastPO} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="Category" name="category">
                <Input size="large"
                  // setCategory
                  onChange={(value) => {
                    setCategory(value);
                  }}
                />
              </Form.Item>
            </Col>

            {/* Vendor */}
            <Col span={8}>
              <Form.Item
                label="Select Vendor"
                name="vendor_id"
                rules={[{ required: true, message: "Please select a vendor" }]}
              >
                <Select
                  size="large"
                  placeholder="Choose Vendor"
                  options={vendorOption}
                  onChange={(value) => {
                    handleChange(
                      vendorOption.id ?? vendorOption.key,
                      "vendor_id",
                      value
                    );
                    setVendorId(value);
                  }}
                />
              </Form.Item>
            </Col>

            {/* Buttons */}
            <Col span={4}>

              <Form.Item
                label=" "
                name=" "
              >

                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    size="large"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={handleNewAdd}
                  >
                    Add Row
                  </Button>

                  <Button danger size="large" onClick={() => setDataSource([])}>
                    Clear
                  </Button>
                </div>
              </Form.Item>

            </Col>

          </Row>
        </Form>
      </Card>


      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowKey="key"
        summary={() => {
          let totalQty = 0;
          let totalprice = 0;

          dataSource.forEach(({ qty, totalprice: rowTotal }) => {
            totalQty += qty || 0;
            totalprice += rowTotal || 0;
          });

          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <Text strong>Total</Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}>
                <Text strong>{totalQty}</Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}></Table.Summary.Cell>
              <Table.Summary.Cell index={4}>
                <Text strong>{totalprice}</Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}></Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </>
  );
};

export default BlukExpense;
